import type {
	PresentationRichTextInline,
	PresentationRichTextNode,
	PresentationRichTextV1,
} from "./presentation-rich-text-v1";

function inlinesToPlain(
	inlines: PresentationRichTextInline[] | undefined,
): string {
	if (!inlines || inlines.length === 0) {
		return "";
	}
	let out = "";
	for (const node of inlines) {
		if (node.type === "hardBreak") {
			out += "\n";
		} else {
			out += node.text;
		}
	}
	return out;
}

function blockToPlain(block: PresentationRichTextNode): string {
	if (block.type === "paragraph") {
		return inlinesToPlain(block.content);
	}
	if (block.type === "listItem") {
		return (block.content ?? []).map(blockToPlain).join("\n");
	}
	if (block.type === "bulletList" || block.type === "orderedList") {
		const items = block.content ?? [];
		return items
			.map((item, index) => {
				const body = blockToPlain(item).trim();
				if (body.length === 0) {
					return "";
				}
				const prefix =
					block.type === "orderedList" ? `${index + 1}. ` : "• ";
				return `${prefix}${body}`;
			})
			.filter((line) => line.length > 0)
			.join("\n");
	}
	return "";
}

/** Plain speakable / dwell text — marks and tags never appear. */
export function presentationRichTextToPlainText(
	doc: PresentationRichTextV1,
): string {
	const parts = (doc.content ?? [])
		.map(blockToPlain)
		.map((part) => part.trim())
		.filter((part) => part.length > 0);
	return parts.join("\n\n");
}
